import { useEffect, useState } from 'react';
import API from '../../api';
import Table from '../smallComponent/Table';
import { useCustomers } from '../context/CustomerContext';

function FollowupList() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState({});
   const { allCustomers,  fetchCustomers } = useCustomers();
  

  const getTodayInIndia = () => {
    return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
  };


  useEffect(() => {
    if (allCustomers && allCustomers.length > 0) {
            const today = getTodayInIndia();

      const filtered = allCustomers.filter(customer =>
        customer.status === 0 &&
        new Date(customer.future_call_date).toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        }) === today
      );
      setCustomers(filtered);

    }
    setLoading(false);
     fetchCustomers();
  }, [allCustomers]);

  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await API.get('/me', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrentUser(res.data);
    } catch (err) {
      console.error("Failed to fetch current user");
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    fetchCustomers();
  }, []);

  const updateFutureCall = async (id, date) => {
    try {
      await API.post(`/customers/${id}/futurecall`, { future_call_date: date });
      fetchCustomers();
    } catch {
      alert("Failed to update future call date");
    }
  };

  const updateLeadParsent = async (id, percent) => {
    try {
      await API.put(`/customers/${id}/lead-parsent`, { lead_parsent: percent });
      fetchCustomers();
    } catch {
      alert("Failed to update lead %");
    }
  };

  const markNI = async (id) => {
    if (!window.confirm("Mark as Not Interested?")) return;
    try {
      await API.put(`/customers/${id}/mark-ni`);
      fetchCustomers();
    } catch {
      alert("Failed to mark NI");
    }
  };

  const renderProgressBar = (percent) => {
    let color = 'bg-green-600';
    if (percent <= 30) color = 'bg-red-600';
    else if (percent <= 70) color = 'bg-yellow-400';

    return (
      <div>
        <div className="mb-2 h-5 w-full border-2 border-black rounded overflow-hidden">
          <div
            className={`${color} h-full text-center text-white text-xs`}
            style={{ width: `${percent}%` }}
          >
            {percent}%
          </div>
        </div>
      </div>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    const offset = d.getTimezoneOffset();
    const localDate = new Date(d.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
  };

  return (
    <div className="container mx-auto mt-4 px-4">
      <h4 className="mb-3 text-xl font-semibold">Today Follow-Up & Status</h4>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table
          customers={customers}
          formatDate={formatDate}
          updateFutureCall={updateFutureCall}
          updateLeadParsent={updateLeadParsent}
          renderProgressBar={renderProgressBar}
          markNI={markNI}
          setCustomers={setCustomers}
          currentUser={currentUser}
        />
      )}
    </div>
  );
}

export default FollowupList;
